// extracted by mini-css-extract-plugin
module.exports = {"root":"Setup__root","panel":"Setup__panel","link_group":"Setup__link_group","label":"Setup__label","link":"Setup__link","big":"Setup__big"};